import { isMediaUrlDifferentOrExpiring } from './isMediaUrlDifferentOrExpiring';

/**
 * Compares image strings from user submitted input, and returns data to ensure
 * proper optimistic updates, as well as prevent unnecessary re-renders.
 * @param {Object} existing
 * @param {Object} incoming
 * @returns {Object}
 */
export const imageMerge = (existing, incoming) => {
  if (incoming === null) {
    return null;
  }

  if (existing?.image32 && incoming?.image32) {
    /**
     * short circuit token check if blob URL
     */
    const isBlobUrl = RegExp('^(blob:https?:)').test(incoming.image32);
    if (isBlobUrl) return incoming;

    /**
     * arbitrarily picking the lowest res to compare tokens on update.
     * since all proxies are updated together, the expiries should be
     * equivalent.
     *
     * this will likely become unnecessary once
     * https://frame.quip.com/U5rCA2MOwcDk/Secure-Edge-Browser-Caching
     * is implemented.
     */
    const shouldUseIncoming = isMediaUrlDifferentOrExpiring({
      current: existing.image32,
      next: incoming.image32,
    });

    return shouldUseIncoming ? incoming : existing;
  }

  return { ...existing, ...incoming };
};
